import EligibilityStatusConstants from "../../constants/EligibilityStatusConstants";
import PendingButtonFormatter from "./PendingButtonFormatter";
import ApprovedButtonFormatter from "./ApprovedButtonFormatter";
import DeniedButtonFormatter from "./DeniedButtonFormatter";
import React, { useContext, useState } from "react";
import { useAlert } from "../hooks/useAlert";
import EligibilityListApi from "../../httpClients/EligibilityListApi";
import { AlertConstants } from "best-common-react";
import PropTypes from "prop-types";
import WBCYearsContext from "../../contexts/WBCYearsContext";
import PlayerEligibilityContext from "../../contexts/PlayerEligibilityContext";
import GlobalModalContext from "../../contexts/GlobalModalContext";

const EligibilityButtonFormatter = ({ row, onOpenEligibilityModal }) => {
  const { selectedYear } = useContext(WBCYearsContext);
  const playerEligibilityContext = useContext(PlayerEligibilityContext);
  const globalModalContext = useContext(GlobalModalContext);
  const [settingToPending, setSettingToPending] = useState(false);

  const showAlert = useAlert();
  const { teamId } = playerEligibilityContext.state.team;

  const onPendingClick = () => {
    if (!settingToPending) {
      setSettingToPending(true);

      EligibilityListApi.setToPendingProfileEligibility(selectedYear, row.fedTeamId, row.profileId)
        .then(() => {
          showAlert("Pending");
          EligibilityListApi.getPlayerEligibilityList(selectedYear, teamId)
            .then(response => {
              playerEligibilityContext.dispatch({ type: "setPlayers", players: response });
              setSettingToPending(false);
            })
            .catch(() => setSettingToPending(false));
        })
        .catch(({ response }) => {
          setSettingToPending(false);
          showAlert(response.data.message, AlertConstants.TYPES.DANGER);
        });
    }
  };

  const onDenyClick = () => {
    globalModalContext.dispatch({
      type: "openDenyEligibilityModal",
      content: { profileId: row.profileId, teamId: row.fedTeamId },
      headerText: `Player Eligibility for ${row.lastName}, ${row.firstName}`,
      closeCallback: () => {
        playerEligibilityContext.dispatch({ type: "setPlayerProfileToDenyReason", reason: null });
      }
    });
  };

  const renderButton = () => {
    switch (row.eligibilityStatusId) {
      case EligibilityStatusConstants.STATUS.PENDING:
        return <PendingButtonFormatter onApproveClick={() => onOpenEligibilityModal(row)} onDenyClick={onDenyClick} />;
      case EligibilityStatusConstants.STATUS.APPROVED:
        return <ApprovedButtonFormatter onPendingClick={onPendingClick} onDenyClick={onDenyClick} />;
      case EligibilityStatusConstants.STATUS.DENIED:
        return (
          <DeniedButtonFormatter onPendingClick={onPendingClick} onApproveClick={() => onOpenEligibilityModal(row)} />
        );
      default:
        return <></>;
    }
  };

  return renderButton();
};

EligibilityButtonFormatter.propTypes = {
  row: PropTypes.object,
  onOpenEligibilityModal: PropTypes.func.isRequired
};

export default EligibilityButtonFormatter;
